import { Link } from "react-router-dom";
import Icon from "@/components/feature/Icon";
import { useSiteSettings } from "@/lib/siteSettings";

export default function CTASection() {
  const { settings } = useSiteSettings();
  // 邀請制（預設）時不招募線上申請，改為介紹會員權益與入會方式
  const applicationsOpen = settings.membership.applications_open;
  return (
    <section className="py-20 md:py-28 bg-navy-950 relative overflow-hidden">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 800 400" preserveAspectRatio="none">
          <defs>
            <pattern id="cta-grid" width="60" height="60" patternUnits="userSpaceOnUse">
              <circle cx="30" cy="30" r="1.5" fill="white" />
              <line x1="30" y1="30" x2="60" y2="30" stroke="white" strokeWidth="0.3" />
              <line x1="30" y1="30" x2="30" y2="60" stroke="white" strokeWidth="0.3" />
            </pattern>
          </defs>
          <rect width="800" height="400" fill="url(#cta-grid)" />
        </svg>
      </div>

      <div className="relative z-10 px-6 md:px-10 lg:px-16">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left - Membership CTA */}
          <div className="text-white">
            <p className="text-sm font-medium tracking-widest text-silver-400 uppercase mb-4">
              {applicationsOpen ? "加入會員" : "會員專區"}
            </p>
            <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold mb-6">
              {applicationsOpen ? "加入 TAIAA" : "與 TAIAA"}
              <br />
              <span className="text-silver-300">共創產業未來</span>
            </h2>
            <p className="text-silver-300 text-base md:text-lg leading-relaxed mb-8 max-w-lg">
              {applicationsOpen
                ? "成為 TAIAA 會員，享有活動優先報名、專屬講座、產業報告、交流社群與合作曝光機會，與台灣 AI 生態系共同成長。"
                : "TAIAA 會員採邀請制。會員享有活動優先報名、專屬講座、產業報告、交流社群與合作曝光機會，與台灣 AI 生態系共同成長。"}
            </p>
            <div className="flex flex-wrap gap-4">
              {applicationsOpen ? (
                <Link
                  to="/membership#join"
                  className="inline-flex items-center gap-2 bg-white text-navy-950 px-6 py-3.5 rounded-full text-sm font-medium hover:bg-silver-100 transition-colors whitespace-nowrap"
                >
                  線上申請
                  <Icon className="ri-arrow-right-line" />
                </Link>
              ) : (
                <Link
                  to="/membership"
                  className="inline-flex items-center gap-2 bg-white text-navy-950 px-6 py-3.5 rounded-full text-sm font-medium hover:bg-silver-100 transition-colors whitespace-nowrap"
                >
                  會員權益
                  <Icon className="ri-arrow-right-line" />
                </Link>
              )}
              <Link
                to={applicationsOpen ? "/membership" : "/membership#join"}
                className="inline-flex items-center gap-2 border border-white/30 text-white px-6 py-3.5 rounded-full text-sm font-medium hover:bg-white/10 transition-colors whitespace-nowrap"
              >
                {applicationsOpen ? "會員權益" : "入會方式"}
              </Link>
            </div>
          </div>

          {/* Right - Partner CTA */}
          <div className="relative">
            <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-6 md:p-8 border border-white/10">
              <p className="text-sm font-medium tracking-widest text-silver-400 uppercase mb-4">
                合作邀請
              </p>
              <h3 className="text-white text-2xl md:text-3xl font-semibold mb-4">
                攜手推動 AI 生態系
              </h3>
              <p className="text-silver-300 text-sm md:text-base leading-relaxed mb-6">
                無論是企業合作、學術研究、活動贊助或人才媒合，我們誠摯邀請您與 TAIAA 共同推動台灣 AI 產業的永續發展。
              </p>

              <div className="space-y-3 mb-8">
                {[
                  { icon: "ri-service-line", text: "企業合作與技術導入" },
                  { icon: "ri-calendar-event-line", text: "共同舉辦論壇與活動" },
                  { icon: "ri-award-line", text: "贊助與品牌曝光機會" },
                ].map((item) => (
                  <div key={item.text} className="flex items-center gap-3 text-silver-300">
                    <Icon className={`${item.icon} text-lg`} />
                    <span className="text-sm">{item.text}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/contact"
                className="inline-flex items-center gap-2 bg-white text-navy-950 px-6 py-3.5 rounded-full text-sm font-medium hover:bg-silver-100 transition-colors whitespace-nowrap"
              >
                聯絡我們
                <Icon className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}